import type {
    AskNoaSubscriptionAddon,
    WinckSubscriptionAddon,
} from '@keyvue/one-api-client';

export default class AdditionalCostsCalculator {
    static winckAddonCosts = {
        users: 2.5,
        contacts: 25,
        brands: 75,
        premiumFlows: 30,
        aiEmployees: 99,
    };

    static askNoaAddonCosts = {
        aiEmployees: 50,
    };

    static contactIncrement = 2500;

    static calculateForWinck(winckSubscriptionAddon: WinckSubscriptionAddon | null): number {
        if (!winckSubscriptionAddon) {
            return 0;
        }

        return [
            winckSubscriptionAddon.brands * AdditionalCostsCalculator.winckAddonCosts.brands,
            winckSubscriptionAddon.users * AdditionalCostsCalculator.winckAddonCosts.users,
            (winckSubscriptionAddon.contacts / AdditionalCostsCalculator.contactIncrement) * AdditionalCostsCalculator.winckAddonCosts.contacts,
            winckSubscriptionAddon.premiumFlows * AdditionalCostsCalculator.winckAddonCosts.premiumFlows,
            winckSubscriptionAddon.aiEmployees * AdditionalCostsCalculator.winckAddonCosts.aiEmployees,
        ].reduce((partialSum, price) => partialSum + price, 0);
    }

    static calculateForAskNoa(askNoaSubscriptionAddon: AskNoaSubscriptionAddon | null): number {
        if (!askNoaSubscriptionAddon) {
            return 0;
        }

        return [
            askNoaSubscriptionAddon.aiEmployees * AdditionalCostsCalculator.askNoaAddonCosts.aiEmployees,
        ].reduce((partialSum, price) => partialSum + price, 0);
    }
}
